import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
export var StyledFlyoverWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: inline;\n"])));
export var StyledFlyover = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmin-width: 160px;\n\ttransition: 300ms opacity;\n\toutline: none;\n"])));